export const SignupState = {
  NEEDS_AUTH: 'NEEDS_AUTH',
  NEEDS_PROFILE: 'NEEDS_PROFILE',
  NEEDS_ORGANIZATION: 'NEEDS_ORGANIZATION',
  NEEDS_SUBSCRIPTION: 'NEEDS_SUBSCRIPTION',
  COMPLETE: 'COMPLETE'
}; 